export default __webpack_public_path__ + "static/media/wd-img.423794cf.png";